import styled from 'styled-components';
import {Button} from "@mui/material";


export const StyledPrimaryActionButton = styled(Button)`
    && {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        gap: 6px;
        padding: 8px 16px;

        @media (max-width: 399px) {
            width: 100%;
        }
    }
`;